import {LoadTask} from './LoadTask.js';

/**
 * Loads the asset at the specified url and converts it to an "objectURL", suitable for caching
 * binary assets such as images and videos. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
 */
export class LoadObjectURLTask extends LoadTask {
  constructor (url, {headersObj = null, nocache = false, params = {}} = {}) {
    super(url, {headersObj: headersObj, nocache: nocache, params: params});
    this.name = 'LOAD_OBJECTURL';
    this.objectURL = null;
    this.type = null;
  }

  handleSuccess (response) {
    response.blob().then(blob => {
      this.objectURL = URL.createObjectURL(blob);
      this.type = blob.type;
      this.done();
    });
  }
}